import React from 'react';
import { motion } from 'framer-motion';

export const SidebarItem = ({ icon: Icon, label, count, active, onClick, nested, isCollapsed }) => (
    <motion.div
        whileHover={{ x: isCollapsed ? 0 : 4 }}
        whileTap={{ scale: 0.98 }}
        onClick={onClick}
        title={isCollapsed ? label : ''}
        className={`nav-item ${active ? 'active' : ''}`}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: isCollapsed ? 'center' : 'space-between',
            padding: isCollapsed ? '10px 0' : '10px 16px',
            paddingLeft: (nested && !isCollapsed) ? '32px' : (isCollapsed ? '0' : '16px'),
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            position: 'relative',
            overflow: 'hidden',
            width: '100%'
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', zIndex: 1, justifyContent: isCollapsed ? 'center' : 'flex-start', width: '100%' }}>
            {Icon && <Icon size={20} style={{ opacity: active ? 1 : 0.6, flexShrink: 0 }} />}
            {!isCollapsed && (
                <span style={{ fontSize: '0.95rem', fontWeight: active ? '600' : '500', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                    {label}
                </span>
            )}
        </div>
        {!isCollapsed && count && (
            <motion.span
                initial={{ scale: 0.8 }}
                animate={{ scale: 1 }}
                style={{
                    fontSize: '0.75rem',
                    background: 'var(--primary)',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '10px',
                    fontWeight: '700',
                    boxShadow: '0 2px 8px var(--primary-glow)'
                }}
            >
                {count}
            </motion.span>
        )}

        {isCollapsed && count && (
            <div style={{
                position: 'absolute',
                top: '5px',
                right: '15px',
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: 'var(--primary)',
                boxShadow: '0 0 5px var(--primary-glow)'
            }} />
        )}

        {active && (
            <motion.div
                layoutId="active-pill"
                style={{
                    position: 'absolute',
                    left: 0,
                    top: '20%',
                    bottom: '20%',
                    width: '4px',
                    backgroundColor: 'var(--primary)',
                    borderRadius: '0 4px 4px 0',
                    boxShadow: '0 0 10px var(--primary-glow)'
                }}
            />
        )}
    </motion.div>
);
